import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import { Button, Input, Select, Table, Tooltip } from "antd";
import authHeader from "../Authentication/authHeader";
import { Link } from "react-router-dom/";
import PortraitIcon from "@mui/icons-material/Portrait";

export default function RetailerDashboard() {
  const { Option } = Select;
  const { Search } = Input;
  const [retailerList, setRetailerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retailerCountData, setRetailerCountData] = useState({});
  const [retailerFilterData, setRetailerFilterData] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/retailer/retailerCount/${retailerFilterData}/`, {
        headers: authHeader(),
      })
      .then((results) => {
        setRetailerCountData(results?.data);
      });
  }, [retailerFilterData]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.baseUrl}/retailer/retailerList/`, {
        headers: authHeader(),
        params: {
          page: currentPage,
          filter: filter,
        },
      })
      .then((results) => {
        setRetailerList(results?.data.results || []);
        setTotalItems(results?.data.count || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currentPage, filter]);

  const columns = [
    {
      title: "Retailer ID",
      dataIndex: "retailer_id",
      width: "20%",
    },
    {
      title: "Retailer Name",
      dataIndex: "name",
      width: "15%",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text) => {
        return "0" + text; // Add '0' to the beginning of the phone number
      },
    },
    {
      title: "District",
      render: (record) => record?.district?.district_name,
      width: "12%",
    },
    {
      title: "Upazila",
      render: (record) => record?.upazila?.upazila_name,
      width: "12%",
    },
    {
      title: "Union",
      render: (record) => record?.union?.union_name,
      width: "12%",
    },
    {
      title: "Action",
      key: "actions",
      width: "15%",
      render: (record) => (
        <>
          <Link
            className="actionBtnDesign me-4 shadow"
            to={`/retailerProfile/${record?.retailer_id}`}
            target="_blank"
          >
            <Tooltip title="Profile">
              <PortraitIcon />
            </Tooltip>
          </Link>
        </>
      ),
    },
  ];

  const retailerDistrictValue = (value) => {
    setRetailerFilterData(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (value) => {
    setFilter(value);
  };

  return (
    <div className="farmerDashboard">
      <div className="dashboardNameSection">
        <h5 style={{ color: "#46604A" }}>RETAILER'S DASHBOARD</h5>
      </div>
      <div className="farmerDashboardContainer shadow-sm rounded">
        <div className="farmerBoxSection">
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Total Registered Retailer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {retailerCountData?.total_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Livestock Retailer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {retailerCountData?.livestock_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Crop Retailer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {retailerCountData?.crop_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Both Retailer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {retailerCountData?.crop_livestock_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="mt-3 ms-3">District Filter:</p>
            <Select
              className="ms-3 w-50"
              name="Select"
              onChange={retailerDistrictValue}
              placeholder="Select District"
              showSearch
            >
              <Option value="all">District</Option>
              {retailerCountData?.district_values?.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="m-2 mt-4 d-flex justify-content-end align-items-center">
          <Search
            className="w-25"
            placeholder="search here..."
            allowClear
            onSearch={handleFilterChange}
            enterButton={
              <Button
                style={{
                  backgroundColor: "#46604A",
                  borderColor: "#46604A",
                  color: "white",
                }}
              >
                Search
              </Button>
            }
          />
        </div>

        <div className="m-2 border">
          <Table
            columns={columns}
            dataSource={retailerList}
            loading={loading}
            rowKey={(record) => record.retailer_id}
            pagination={{
              current: currentPage,
              total: totalItems,
              pageSize: 10, // Set the number of items per page
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </div>
  );
}
